import React, { useMemo, useCallback } from 'react'

import { useDialog } from '@galo-monitor/dialog'
import { useT } from '@galo-monitor/i18n'
import useGaloMonitorApi from '@galo-monitor/services/hooks/useGaloMonitorApi'
import DataTable from '@galo-monitor/web-components/DataTable'
import FertilizerManufacturerModal from '@galo-monitor/web-containers/modals/root/FertilizerManufacturerModal'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

const Fertilizers = () => {
  const t = useT()
  const { createDialog } = useDialog()
  const { routes, getActionsBySlug } = useRoutes()

  const { data: manufacturers, mutate, isValidating } = useGaloMonitorApi('/admin/fertilizer-makers')

  const userActions = useMemo(
    () => getActionsBySlug(routes.fertilizers.slug),
    [getActionsBySlug, routes.fertilizers.slug]
  )

  const columns = useMemo(
    () => [
      {
        title: t('manufacturer', { howMany: 1 }),
        field: 'name'
      }
    ],
    [t]
  )

  const onAddClick = useCallback(
    () => {
      createDialog({
        id: 'create-fertilizer-manufacturer',
        Component: FertilizerManufacturerModal,
        props: {
          onSuccess: mutate
        }
      })
    },
    [createDialog, mutate]
  )

  const onEditClick = useCallback(
    (_, manufacturer) => {
      createDialog({
        id: 'edit-fertilizer-manufacturer',
        Component: FertilizerManufacturerModal,
        props: {
          manufacturer,
          onSuccess: mutate
        }
      })
    },
    [createDialog, mutate]
  )

  return (
    <DataTable
      loading={ isValidating }
      data={ manufacturers || [] }
      columns={ columns }
      onAddClick={ userActions.write && onAddClick }
      onEditClick={ userActions.edit && onEditClick }
    />
  )
}

export default Fertilizers
